"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var addParamsToUrl_1 = __importDefault(require("./addParamsToUrl"));
var removeFromUrl_1 = __importDefault(require("./removeFromUrl"));
/**
 * Add the from url to a `from_url` parameter and tack it onto an href. That
 * way, if you navigate to that page, you can keep track of where you came from.
 * Currently used by the support form to send the problem url.
 *
 * @example
 *  addFromUrl('/app/dashboard', '/app/settings')
 *  > '/app/dashboard?from_url=/app/settings'
 */
var addFromUrl = function (targetHref, currentHref) {
    if (!currentHref || !targetHref)
        return targetHref !== null && targetHref !== void 0 ? targetHref : '';
    var currentUrl = removeFromUrl_1.default(String(currentHref));
    return addParamsToUrl_1.default(targetHref, { from_url: currentUrl });
};
exports.default = addFromUrl;
